export default __webpack_public_path__ + "static/media/spiderman-img-3.e42b4674.png";